import React, { useState } from "react";
import "./Navbar.css";

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="nav-wrapper">
      <div className="navbar">

        {/* Logo */}
        <div className="logo">
          <img src="/images/logo.png" alt="logo" />
        </div>

        {/* HAMBURGER */}
        <div className="hamburger" onClick={() => setOpen(!open)}>
          <i className="fa-solid fa-bars"></i>
        </div>

        {/* MENU */}
        <ul className={`menu ${open ? "active" : ""}`}>
          <li><a href="/" onClick={() => setOpen(false)}>Home</a></li>
          <li><a href="#about-us" onClick={() => setOpen(false)}>About</a></li>
          <li><a href="#council" onClick={() => setOpen(false)}>Council</a></li>
          <li><a href="#gallery" onClick={() => setOpen(false)}>Gallery</a></li>
          <li><a href="#contact" onClick={() => setOpen(false)}>Contact</a></li>
        </ul>

        {/* CTA */}
        <a href="#contact" className="nav-cta">
          <button className="nav-btn">
            Contact Us <span>→</span>
          </button>
        </a>

      </div>
    </div>
  );
};

export default Navbar;